module.exports = __webpack_public_path__ + "static/media/logoHack.01898204.png";